import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
    AllowedItemChange,
    BreadcrumbData,
} from 'src/app/Modules/settings/components/settings-informate/components/instance-configuration/instance-configuration.component';
import { AllowedItem } from 'src/app/Modules/settings/models/informate/allowed-item';
import { InstanceDataService } from 'src/app/services/instance-data.service';

@Component({
    selector: 'app-instance-configuration-data',
    templateUrl: './instance-configuration-data.component.html',
    styleUrls: ['./instance-configuration-data.component.scss'],
})
export class InstanceConfigurationDataComponent implements OnInit, OnDestroy {
    @Input() public selectAll: boolean = false;

    @Input()
    set allowedItem(value: AllowedItem[]) {
        if (value !== null && value !== undefined) {
            this._allowedItem = value;
            this.allowedItemsToDisplay = value;
            this.cd.markForCheck();
        }
    }
    get allowedItem(): AllowedItem[] {
        return this._allowedItem;
    }

    @Input()
    set breadcrumbData(value: BreadcrumbData[]) {
        if (value !== null && value !== undefined) {
            this._breadcrumbData = value;
            this.cd.markForCheck();
        }
    }
    get breadcrumbData(): BreadcrumbData[] {
        return this._breadcrumbData;
    }
    @Output() dataChangeEvent: EventEmitter<AllowedItemChange> = new EventEmitter();
    @Output() selectAllClicked = new EventEmitter<boolean>(false);
    @Output() dataClickEvent: EventEmitter<AllowedItem> = new EventEmitter();
    @Output() allowedItemBreadCrumbClicked: EventEmitter<BreadcrumbData> = new EventEmitter();
    destroy$ = new Subject();

    tooltip_position = 'above';
    allowedItemsToDisplay: AllowedItem[];
    public _breadcrumbData: BreadcrumbData[];
    private _allowedItem: AllowedItem[];
    constructor(
        private cd: ChangeDetectorRef,
        private instanceDataService: InstanceDataService
    ) {}

    ngOnInit(): void {
        this.instanceDataService.AllowedItemsselectAll.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.selectAll = res;
            this.cd.detectChanges();
        });
    }

    selectionChange(event: MatCheckboxChange, allowedItem: AllowedItem) {
        let idArray = this.breadcrumbData.map((a) => a.id);
        if (idArray[idArray.length - 1] != allowedItem.itemId) {
            idArray.push(allowedItem.itemId);
        }
        //this.dataChangeEvent.emit({ itemIds: idArray, allowed: event.checked });
        if (this.checkAllowedItemUpdate(this.allowedItemsToDisplay, false) != true) {
            // this.selectAll = true;
            this.dataChangeEvent.emit({ itemIds: idArray, allowed: event.checked });
        } else {
            this.selectAll = false;
            this.dataChangeEvent.emit({ itemIds: idArray, allowed: event.checked });
        }
        //this.dataChangeEvent.emit({ itemIds: idArray, allowed: event.checked });
    }

    checkAllowedItemUpdate(ItemsToDisplay: any[], flag: boolean): boolean {
        let flg = false;
        for (let i = 0; i < ItemsToDisplay.length; i++) {
            if (ItemsToDisplay[i].items?.length > 0) {
                if (this.checkAllowedItemUpdate(ItemsToDisplay[i].items, flag)) flg = true;
            } else {
                if (ItemsToDisplay[i].allowed != true) flg = true;
            }
        }
        return flg;
    }

    selectionChangeAll(event: MatCheckboxChange) {
        this.selectAllClicked.emit(true);
        this.getAllowedItemUpdate(this.allowedItemsToDisplay, event.checked);
    }

    getAllowedItemUpdate(ItemsToDisplay: any[], status: boolean) {
        for (let i = 0; i < ItemsToDisplay.length; i++) {
            if (ItemsToDisplay[i].items?.length > 0) {
                this.getAllowedItemUpdate(ItemsToDisplay[i].items, status);
            } else {
                ItemsToDisplay[i].allowed = status;
            }
        }
        this.selectAll = status;
    }

    loadData(allowedItem: AllowedItem) {
        this.selectAll = false;
        this.instanceDataService.selectedAllowedItems.next(allowedItem);
    }

    refreshData(data: BreadcrumbData) {
        this.allowedItemBreadCrumbClicked.emit(data);
    }

    getGroupCheckedStatus(allowedItem: AllowedItem): boolean {
        //level 0
        if (allowedItem.items == undefined || allowedItem.items == null) {
            return allowedItem.allowed;
        }
        //level 1
        else if (allowedItem.items.every((x) => x.items == undefined)) {
            return allowedItem.items.every((x) => x.allowed == true);
        }
        //level 2
        else return allowedItem.items.every((x) => x.items.every((y) => y.allowed == true) == true);
    }

    ngOnDestroy() {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
